import { LOCK_SCROLL, SET_PENDING_AUTOSCROLL, UNLOCK_SCROLL } from 'reducers/actions-types';
import viewportActions from 'reducers/modules/viewport/actions';

export default Object.freeze({
    /**
     * Locking scroll
     * @param {boolean} hasOverlay
     * @return {Function}
     */
    lock(hasOverlay) {
        return (dispatch) => {
            if (hasOverlay !== false) {
                dispatch(viewportActions.setOverlay({ hasOverlay: true }));
            }
            dispatch({ type: LOCK_SCROLL });
        };
    },

    /**
     * Unlock scroll
     * @return {Function}
     */
    unlock() {
        return (dispatch) => {
            dispatch(viewportActions.setOverlay({ hasOverlay: false }));
            dispatch({ type: UNLOCK_SCROLL });
        };
    },

    /**
     * Set pending autoscroll
     * @param {boolean} mustAutoscroll
     */
    setPendingAutoscroll({ mustAutoscroll }) {
        return { type: SET_PENDING_AUTOSCROLL, mustAutoscroll };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/scroll/actions.js